var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.details
    ? _c(
        "div",
        { attrs: { id: "invoiceDetail" } },
        [
          _c("AppBreadCrumb", {
            attrs: {
              paths: [
                {
                  title: _vm.$t("billing.invoiceManagement"),
                  path: "/billing",
                },
                { title: "Fatura Detay" },
              ],
              select: true,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "invoice-detail-content" }, [
            _c("div", { staticClass: "invoice" }, [
              _c(
                "div",
                {
                  staticClass: "invoice-head",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _c("div", { staticClass: "row-item" }, [
                    _c("div", { staticClass: "column-item" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("billing.site"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.siteName)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column-item" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("billing.period"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.details.period)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "column-item",
                        staticStyle: { width: "30%" },
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("billing.billStatus"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.details.paid
                                ? _vm.$t("billing.paid")
                                : _vm.$t("billing.unPaid")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class:
                        (_vm.invoice.type === "manuel" ||
                          _vm.invoice.isManuel) &&
                        _vm.invoice.description
                          ? "row-item-space-between"
                          : "row-item-end",
                    },
                    [
                      _vm.invoice.description
                        ? _c("div", { staticClass: "column-item" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.$t("message.description"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.invoice.description)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "column-item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("billing.totalPrice"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(~~(_vm.invoice.price || 0)) + "₺"),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.details.plans.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "invoice-head",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _c("div", { staticClass: "row-item" }, [
                        _c("div", { staticClass: "column-item" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("instagram.detail"))),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.details.plans.length > 0
                ? _c(
                    "div",
                    { staticClass: "details" },
                    _vm._l(_vm.details.plans, function (planGroup) {
                      return _c("div", { staticClass: "detail-content" }, [
                        _c("div", { staticClass: "head" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(planGroup.title) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          planGroup.price > 0
                            ? _c("div", { staticClass: "price" }, [
                                _vm._v(_vm._s(~~(planGroup.price || 0)) + "₺"),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "content" },
                          _vm._l(planGroup.items, function (item) {
                            return _c(
                              "div",
                              { staticClass: "detail-content-child" },
                              [
                                _c("div", { staticClass: "head" }, [
                                  _c("div", { staticClass: "title" }, [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        -\n                                        "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(item.title) +
                                            "\n                                            " +
                                            _vm._s(
                                              item.planType === "storage"
                                                ? "(" +
                                                    item.details.exceededSpace.toFixed(
                                                      2
                                                    ) +
                                                    "GB)"
                                                : ""
                                            ) +
                                            "\n                                            " +
                                            _vm._s(
                                              item.planType === "automation"
                                                ? _vm.isFreePlan(item)
                                                  ? "(Free Plan)"
                                                  : "(" +
                                                    _vm.getSelectedCount(item) +
                                                    " Tasks)"
                                                : ""
                                            ) +
                                            "\n                                            " +
                                            _vm._s(
                                              item.planType === "supsis"
                                                ? "(" +
                                                    item.details.agentCount +
                                                    " Agent) " +
                                                    (item.details.freeAgentCount
                                                      ? "(+" +
                                                        item.details
                                                          .freeAgentCount +
                                                        " Ücretsiz)"
                                                      : "")
                                                : [
                                                    "whatsapp-business",
                                                    "whatsapp",
                                                    "instagram",
                                                    "messenger",
                                                    "trendyol",
                                                  ].includes(item.planType)
                                                ? "(" +
                                                  item.details.channelCount +
                                                  " Kanal)"
                                                : item.planType === "chatbot"
                                                ? "(" +
                                                  item.details
                                                    .totalChatbotSessionCount +
                                                  " Chatbot)"
                                                : ""
                                            ) +
                                            "\n                                            " +
                                            _vm._s(
                                              item.planType === "mail"
                                                ? _vm.isFreePlan(item)
                                                  ? "(Free Plan)"
                                                  : "(" +
                                                    _vm.getSelectedCount(item) +
                                                    " Mail)"
                                                : ""
                                            ) +
                                            "\n                                        "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          item.startDate
                                            ? item.startDate +
                                                " - " +
                                                item.endDate
                                            : ""
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  item.price > 0
                                    ? _c("div", { staticClass: "price" }, [
                                        _vm._v(_vm._s(item.price) + "₺"),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }